/*
 * KAPstat wordmark — "KAP" + an ECG/pulse glyph + "stat".
 * Copyright (c) 2026 Eddlynn Edtech Private Limited.
 */
export function Wordmark({ height = 26, accent = '#22E3C3' }) {
  // Inherits the surrounding text colour so it adapts to the active theme.
  return (
    <span className="wm" style={{ fontSize: height, color: 'inherit' }} aria-label="KAPstat">
      <span className="wm__kap">KAP</span>
      <svg className="wm__pulse" viewBox="0 0 34 24" height={height * 0.7} aria-hidden="true">
        <path d="M0 12 H8 L11 4 L15 20 L19 9 L22 12 H34" fill="none"
          stroke={accent} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      <span className="wm__stat">STAT</span>
    </span>
  );
}
